import React from 'react';
import ReactDOM from 'react-dom';
import { DeleteOutlined } from '@ant-design/icons';
import { COVERAGE_LAYER_ID, CoverageHelper } from './CoverageHelper';
import { ThemeProvider } from 'oskari-ui/util';
import { MapModuleButton } from '../../../MapModuleButton';
var FEATURE_EVENT_ADD = 'add';
var FEATURE_EVENT_REMOVE = 'remove';
var LOCALIZATION_BUNDLE_ID = 'MapModule';
Oskari.clazz.define('Oskari.mapframework.bundle.mapmodule.plugin.CoverageToolPlugin',
/**
 * @method create called automatically on construction
 * @static
 */
function (config) {
  this._clazz = 'Oskari.mapframework.bundle.mapmodule.plugin.CoverageToolPlugin';
  this._defaultLocation = 'top center';
  this._templates = {
    plugin: jQuery('<div class="mapplugin coveragetoolplugin"></div>')
  };
  this._visible = false;
  this.coverageHelper = new CoverageHelper();
}, {
  /** @static @property __name module name */
  __name: 'CoverageToolPlugin',
  getName: function getName() {
    return this.__name;
  },
  /**
   * @private @method _createControlElement
   * Creates the DOM element that will be placed on the map
   * @return {jQuery}
   * Plugin jQuery element
   */
  _createControlElement: function _createControlElement() {
    return this._templates.plugin.clone();
  },
  _startPluginImpl: function _startPluginImpl() {
    this.setElement(this._createControlElement());
    this.renderButton();
    this.addToPluginContainer(this.getElement());
  },
  renderButton: function renderButton() {
    var _this = this;
    var el = this.getElement();
    if (!el) {
      return;
    }

    // clear all content from element so the tooltip gets cleared as well
    if (!this.isVisible()) {
      ReactDOM.render(null, el[0]);
      return;
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, {
      value: this.getMapModule().getMapTheme()
    }, /*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_coveragetoolbutton",
      visible: this.isVisible(),
      icon: /*#__PURE__*/React.createElement(DeleteOutlined, null),
      title: Oskari.getMsg(LOCALIZATION_BUNDLE_ID, 'layerCoverageTool.removeCoverageFromMap'),
      onClick: function onClick() {
        return _this._coverageButtonClicked();
      },
      iconActive: !!this.popupOpen,
      position: this.getLocation()
    })), el[0]);
  },
  setVisible: function setVisible(visible) {
    this._visible = visible;
  },
  isVisible: function isVisible() {
    return this._visible;
  },
  _coverageButtonClicked: function _coverageButtonClicked() {
    this.coverageHelper.clearLayerCoverage();
  },
  /**
   * @method _stopPluginImpl BasicMapModulePlugin method override
   * @param {Oskari.Sandbox} sandbox
   */
  _stopPluginImpl: function _stopPluginImpl(sandbox) {
    this.teardownUI();
    this._layers = [];
    this._baseLayers = [];
  },
  /**
   * @method _createEventHandlers
   * Create eventhandlers.
   *
   *
   * @return {Object.<string, Function>} EventHandlers
   */
  createEventHandlers: function createEventHandlers() {
    return {
      FeatureEvent: function FeatureEvent(event) {
        if (!event || !((event === null || event === void 0 ? void 0 : event.getOperation()) === FEATURE_EVENT_ADD || (event === null || event === void 0 ? void 0 : event.getOperation()) === FEATURE_EVENT_REMOVE)) {
          return;
        }
        var features = (event === null || event === void 0 ? void 0 : event.getFeatures()) || null;
        var isCoverageLayer = features === null || features === void 0 ? void 0 : features.some(function (feature) {
          return feature.layerId === COVERAGE_LAYER_ID;
        });
        this.setVisible(isCoverageLayer && event.getOperation() === FEATURE_EVENT_ADD);
        this.renderButton();
      },
      UIChangeEvent: function UIChangeEvent(event) {
        this.coverageHelper.clearLayerCoverage(true);
      }
    };
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});